import React from "react";
import PropTypes from "prop-types";
import classes from "./styles.module.scss";
import VenueTypeOption from "./VenueTypeOption";

const VenueTypeOptions = ({
  value = [],
  onChange,
  options = window.data?.tags
    ?.filter((tag) => tag.parent === "venueType")
    .map((tag) => tag.name),
  gaPrefix,
  blue,
}) => {
  if (!value) value = [];
  const handleChange = (val, checked) => {
    const newValue = checked
      ? [...value, val]
      : value.filter((opt) => opt !== val);
    onChange(newValue);
  };

  return (
    <ul className={classes.VenueTypeOptions}>
      {options.map((tag) => (
        <li key={tag}>
          <VenueTypeOption
            blue={blue}
            name={tag}
            value={tag}
            checked={value.includes(tag)}
            onChange={handleChange}
            gaPrefix={gaPrefix}
          />
        </li>
      ))}
    </ul>
  );
};

VenueTypeOptions.propTypes = {
  value: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.string.isRequired),
  gaPrefix: PropTypes.string,
  blue: PropTypes.bool,
};

export default VenueTypeOptions;
